export default __webpack_public_path__ + "3ab1a4d695f8849e1529d8c0d59f9170.png";